import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './Eyebrow.module.css';

class Eyebrow extends PureComponent {
  render() {
    const { styles, text, children, color } = this.props;
    return (
      <span styleName={`eyebrow ${color || ''}`} style={styles}>
        {children}
        {text}
      </span>
    );
  }
}

Eyebrow.propTypes = {
  styles: PropTypes.array,
  text: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string
};

export default Eyebrow;
